import _defineProperty from "babel-runtime/helpers/defineProperty";

var _imageConfig;

import baseConfig from "./baseConfig";
import defineCfg from "./defineConfig";
var imageConfig = (_imageConfig = {}, _defineProperty(_imageConfig, defineCfg.$definecfg.QSJGDM_CONST.GUOTOU, {
  "leftMenuLogo": require("@img/home/00home/logo.png")
}), _defineProperty(_imageConfig, "getImageLogo", function getImageLogo(key) {
  var qsVersion = baseConfig.$basecfg.qsVersion;
  if (key) {
    return this[qsVersion] && this[qsVersion][key] || this[defineCfg.$definecfg.QSJGDM_CONST.BIAOZHUN][key] || "";
  }
  return "";
}), _imageConfig);

var plugin = {
  install: function install(Vue) {
    Vue.imgcfg = imageConfig;

    Vue.prototype.$imgcfg = imageConfig;
  },

  $imgcfg: imageConfig
};

export default plugin;
export var install = plugin.install;


//////////////////
// WEBPACK FOOTER
// ./src/config/imageConfig.js
// module id = 1412
// module chunks = 2